import React, { memo, useEffect } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";
import { styled } from "@mui/material/styles";
import CloseButton from "./CloseButton";
import useSmoothResponsiveFontSize from "../../_hook/useSmoothResponsiveFontSize";
import { renderContent } from "./SidebarDrawer";

// Styled Footer component with animation
const Footer = styled(motion(Box))(({ theme }) => ({

  color: theme.palette.grey[100],
  width: "100%",
}));

const SidebarDrawerFooter = (props) => {
  const { currentwidth, title, children, ...rest} = props;

  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const customfontsize = useSmoothResponsiveFontSize({});

  useEffect(() => {}, [customfontsize]);

  return (
    <Footer
      animate={{
        width: currentwidth,
      }}
      transition={{
        type: "spring",
        stiffness: 100,
        damping: 20,
      }}
    >
      {title&&(typeof title==="string")?<Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isMobileView ? "center" : "start",
          fontSize: `${customfontsize}px`,
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            color: "grey.100",
            fontSize: `${customfontsize}px`,
            display: "-webkit-box",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap", // Keeps it to a single line
            textTransform: "uppercase",
            textAlign:isMobileView ? "center" : "start",
          }}
        >
          {title}
        </Typography>
      </Box>:renderContent(children, currentwidth, { ...rest })}


    </Footer>
  );
};
export default memo(SidebarDrawerFooter);
